import { createStore } from 'vuex';
import { config } from "@/config/setting";

export default createStore({
    state: {
        title: config.baseTitle,
        BaseTitle: config.baseTitle,
        userInfo: null,
        pageName:""
    },
    mutations: {
        // 设置标题
        setTitle(state,title) {
            state.title = title;
        },
        setUserInfo(state,userInfo) {
            state.userInfo = userInfo;
        },
        setPageName(state,pageName) {
            state.pageName = pageName;
        }
    },
    actions: {
        setTitle({commit},title) {
            commit('setTitle',title);
        },
        setUserInfo({commit},userInfo) {
            commit('setUserInfo',userInfo);
        },
        setPageName({commit},pageName) {
            commit('setPageName',pageName);
        }
    },

    getters: {
        getTitle: state => state.title,
        getBaseTitle: state => state.BaseTitle,
        getUserInfo: state => state.userInfo,
        getPageName: state => state.pageName
    }
});

